import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserLoyaltyResult } from '../model/user.model';
import { ReplaySubject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyService {
  userLoyalty$ = new ReplaySubject<UserLoyaltyResult>(1);
  constructor(private http: HttpClient) { }

  async current() {
    var current = await firstValueFrom(this.http.get<UserLoyaltyResult>('/api/loyalty/current'));
    this.userLoyalty$.next(current);
  }

  async getRewards(mode?: 'admin') {
    return await firstValueFrom(this.http.get<any[]>('/api/loyalty/rewards', { params: { mode } }));
  }

  async saveReward(reward: any) {
    return await firstValueFrom(this.http.post('/api/loyalty/reward', reward));
  }

  async buyReward(rewardId: string) {
    return await firstValueFrom(this.http.post(`/api/loyalty/buy/${rewardId}`, null));
  }
}
